import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import { fullOptionsMap, fullOptionsValueMap, operationTypeOptions, startPkgOptions } from '../options';
import { generateActionBar } from './common';
import {
  conditionAddButtonHeight,
  conditionContentPaddingY,
  conditionRowHeight,
  conditionRowInnerHeight,
  conditionTitleHeight,
  CustomNodeType,
  splitLineHeight,
  splitLineMargin,
  textareaHeight
} from './config';

function clickEvtfn(e) {
  const target = e.target;

  const clickEvtfnMap = {
    // 关联商品清单
    'activity-conditions-link-btn': 'onActivityRuleLinkProducts',
    // 删除
    'activity-conditions-del-btn': 'onActivityDeleteRule',
    // 勾选
    'activity-conditions-check-btn': 'onActivityCheckRule',
    // 添加规则
    'activity-conditions-add-btn': 'onActivityAddRule'
  };

  for (const key in clickEvtfnMap) {
    if (target.classList.contains(key)) {
      const index = Number(target.getAttribute('data-index'));
      const id = target.getAttribute('data-id');

      // @ts-ignore
      window[clickEvtfnMap[key]](id, index);
    }
  }
}

function changeEvtfn(e) {
  const target = e.target;

  const changeEvtfnMap = {
    // 操作类型(满金额、满款数、满数量等)
    'activity-conditions-operations-select': 'onConditionOperationChange',
    // 起订包装
    'activity-conditions-startpkg-select': 'onStartOrderUnitChange',
    // 满单位
    'activity-conditions-fullunit-select': 'onFullUnitChange',
    // 行组合
    'activity-conditions-combine-btn': 'onNodeGrouptypeChange'
  };

  for (const key in changeEvtfnMap) {
    if (target.classList.contains(key)) {
      const index = Number(target.getAttribute('data-index'));
      const id = target.getAttribute('data-id');

      // @ts-ignore
      window[changeEvtfnMap[key]](id, e.target, index);
    }
  }

  // 节点组合
  if (target.classList.contains('activity-conditions-nodecombine-btn')) {
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onNodeGrouptypeChange(id, e.target, 0, true);
  }
}

function inputEvtfn(e) {
  const target = e.target;

  const inputEvtfnMap = {
    // 起订量
    'activity-conditions-startorder-input': 'onConditionOperationValueInput',
    // 满数值
    'activity-conditions-fullnum-input': 'onFullUnitInput'
  };

  for (const key in inputEvtfnMap) {
    if (target.classList.contains(key)) {
      const index = Number(target.getAttribute('data-index'));
      const id = target.getAttribute('data-id');

      // @ts-ignore
      window[inputEvtfnMap[key]](id, e.target, index);
    }
  }
}

function blurEvtfn(e) {
  const target = e.target;

  const blurEvtfnMap = {
    // 活动文案
    'activity-textarea': 'onActivityDescBlur'
  };

  for (const key in blurEvtfnMap) {
    if (target.classList.contains(key)) {
      const id = target.getAttribute('data-id');

      // @ts-ignore
      window[blurEvtfnMap[key]](id, e.target);
    }
  }
}

export const registerConditionShape = (rowData) => {
  G6.registerNode(CustomNodeType.CONDITIONS, {
    draw: (cfg, group) => {
      const jsonData = rowData[cfg.dataId];

      const createConditionRowHtml = () => {
        const conditionData = jsonData[cfg!.isPre ? 'conditions' : 'effectConditions'];
        const combineData = jsonData[cfg!.isPre ? 'conditionsCombine' : 'effectConditionsCombine'];
        let conditionsHtml = ''; // 当前节点所有条件行html
        let combineColHtml = ''; // 当前节点组合列html

        conditionData.forEach((i, index) => {
          conditionsHtml += `
          <div style="display: flex;align-items: center;column-gap: 4px;height: ${conditionRowHeight}px">
            <select data-id="${
              cfg!.id
            }" data-index="${index}" class="activity-conditions-operations-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="">
              ${operationTypeOptions.reduce(
                (t, c) =>
                  t + `<option value="${c.value}" ${i.optionType == c.value ? 'selected' : ''}>${c.label}</option>`,
                ''
              )}
            </select>
            <input data-id="${cfg!.id}"  data-index="${index}" id="input_${
            i._uniqueId
          }" class="activity-conditions-startorder-input condition-number-input" value="${
            i.optionValue
          }" placeholder="数值" style="width: 50px;height: ${conditionRowInnerHeight}px;" />
            <select data-id="${
              cfg!.id
            }"  data-index="${index}" class="activity-conditions-startpkg-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="包装">
            ${startPkgOptions.reduce(
              (t, c) =>
                t + `<option value="${c.value}" ${i.orderUnit == c.value ? 'selected' : ''}>${c.label}</option>`,
              ''
            )}
            </select>
            <span>起订，满</span>
            <input data-id="${cfg!.id}"  data-index="${index}" id="full-unit_${
            i._uniqueId
          }" class="activity-conditions-fullnum-input condition-number-input" value="${
            i.fullNumber
          }" placeholder="数值" style="width: 50px;height: ${conditionRowInnerHeight}px;" />
            <select data-id="${
              cfg!.id
            }"  data-index="${index}" class="activity-conditions-fullunit-select condition-select" style="width: 50px;height: ${conditionRowInnerHeight}px;" placeholder="">
                ${fullOptionsMap[i.optionType].reduce(
                  (t, c) =>
                    t +
                    `<option value="${c.value}" ${i[fullOptionsValueMap[i.optionType]] == c.value ? 'selected' : ''}>${
                      c.label
                    }</option>`,
                  ''
                )}
            </select>
            <div style="display: flex;align-items: center;height: 100;">
              ${
                !cfg!.isPre
                  ? ''
                  : `<span data-id="${
                      cfg!.id
                    }"  data-index="${index}" class="activity-conditions-link-btn iconfont icon-lianjie" style="margin-left:5px;font-size:18px;color:${
                      i.promotionItemStr ? '#d70a25' : '#333'
                    };cursor:pointer;"></span>`
              }
              <span data-id="${
                cfg!.id
              }"  data-index="${index}" class="activity-conditions-del-btn iconfont icon-shanchu" style="margin-left:5px;font-size:18px;color:${
            i.checkedDisabled ? '#999' : '#333'
          };cursor:${i.checkedDisabled ? 'not-allowed' : 'pointer'};"></span>
              ${
                conditionData.length > 1
                  ? `<span data-id="${
                      cfg!.id
                    }"  data-index="${index}" class="activity-conditions-check-btn iconfont icon-${
                      i.checked ? 'checked' : 'unchecked'
                    }" style="margin-left:5px;font-size:18px;color:${i.checkedDisabled ? '#999' : '#333'};cursor:${
                      i.checkedDisabled ? 'not-allowed' : 'pointer'
                    };"></span>`
                  : ''
              }
            </div>
          </div>
        `;
        });

        // 构建组合的行
        if (conditionData.length > 1) {
          combineData.groups.forEach((i, index) => {
            const h = i._uniqueIds.length * conditionRowHeight;
            const inH = h - conditionContentPaddingY * 2;
            combineColHtml += `
          <div style="display: flex;align-items: center;height: ${h}px"">
            <div style="display: flex;align-items: center;height: ${inH}px">
              <div style="display: flex;justify-content:center;width: 60px;height: 100%;background-color: ${
                i.type == 'and' ? 'var(--oio-button-primary-background)' : '#d7d7d7'
              };border-radius: 4px;">
                <select data-id="${
                  cfg!.id
                }" data-index="${index}" class="activity-conditions-combine-btn condition-select" style="width: 100%;height: 100%;border:none;background-color:transparent;color: ${
              i.type == 'and' ? '#fff' : '#000'
            };text-align:center;" placeholder="">
                  <option value="and" ${i.type == 'and' ? 'selected' : ''} style="color: #000">且</option>
                  <option value="or" ${i.type == 'or' ? 'selected' : ''} style="color: #000">或</option>
                  ${i._uniqueIds.length > 1 ? '<option value="cancel" style="color: #000">取消组</option>' : ''}
                </select>
              </div>
            </div>
          </div>
        `;
          });
        }

        // 当前节点最后一列
        const lastColHtml = `
        <div style="padding: ${conditionContentPaddingY}px 0;">
          <div style="display: flex;width: 50px;height: ${
            conditionData.length * conditionRowHeight - conditionContentPaddingY * 2
          }px;background-color: ${
          combineData.type == 'and' ? 'var(--oio-button-primary-background)' : '#d7d7d7'
        };border-radius: 4px;">
            <select data-id="${
              cfg!.id
            }" class="activity-conditions-nodecombine-btn condition-select" style="width: 100%;height: 100%;border:none;background-color:transparent;color: ${
          combineData.type == 'and' ? '#fff' : '#000'
        };text-align:center;" placeholder="">
              <option value="and" ${combineData.type == 'and' ? 'selected' : ''} style="color: #000">且</option>
              <option value="or" ${combineData.type == 'or' ? 'selected' : ''} style="color: #000">或</option>
            </select>
          </div>
        </div>
      `;

        const res = `
        <div style="display: flex;column-gap: 4px;">
          <div>
            ${conditionsHtml}
          </div>
          <div>
            ${combineColHtml}
          </div>
          ${conditionData.length > 1 ? lastColHtml : ''}
        </div>
      `;

        return res;
      };

      // 只监听一次事件
      document.body.removeEventListener('click', clickEvtfn);
      document.body.removeEventListener('change', changeEvtfn);
      document.body.removeEventListener('input', inputEvtfn);
      document.body.removeEventListener('blur', blurEvtfn, true);
      document.body.addEventListener('click', clickEvtfn);
      document.body.addEventListener('change', changeEvtfn);
      document.body.addEventListener('input', inputEvtfn);
      document.body.addEventListener('blur', blurEvtfn, true);

      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div>
            <div style="background-color: #f2f2f2;border-radius:4px;height: 100%;">
              <div style="background-color: ${
                cfg!.style!.titleBgColor
              }; color: #fff; font-size: 12px;text-align: center;border-radius:4px;height: ${conditionTitleHeight}px;line-height: ${conditionTitleHeight}px;">
              ${cfg!.title}
              </div>
              <div style="padding: ${conditionContentPaddingY}px ${conditionContentPaddingY * 2}px;">
                <div>
                  ${createConditionRowHtml()}
                </div>
                <div data-id="${
                  cfg!.id
                }" class="activity-conditions-add-btn" style="height: ${conditionAddButtonHeight}px;border-radius: 4px;border:1px dashed #333;color:#333;text-align:center;font-size:12px;cursor:pointer;">添加规则
                </div>
                <div style="height: ${splitLineHeight}px;margin: ${splitLineMargin}px 0;background-color: ${
            cfg!.isPre ? '#d70a25' : 'var(--oio-button-primary-background)'
          };">
                </div>
                <textarea 
                  class="activity-textarea"
                  data-id="${cfg!.id}"
                  placeholder="${cfg!.isPre ? '请输入必定提示文案' : '请输入活动提示文案'}" 
                  style="width: 100%;height: ${textareaHeight}px;border-radius: 4px;padding: 3px;resize: none;" 
                  rows="3">${cfg!.isPre ? jsonData.conditionDesc : jsonData.effectConditionDesc}</textarea>
              </div>
            </div>
            ${generateActionBar({ ...jsonData, ...cfg })}
          </div>
        `
        }
      });
    }
  });
};
